import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES, IMAGES } from "../../mock";

export default function ServicesShowcase() {
  const [open, setOpen] = useState(0);
  const items = SERVICES.slice(0, 5);
  const activeImg = items[open]?.image || IMAGES.living1;

  return (
    <section className="py-24 bg-[#f7f9fb] overflow-hidden">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Image */}
          <div className="relative reveal-left lg:sticky lg:top-28">
            <div className="shape-leaf">
              <img key={activeImg} src={activeImg} alt="Renovation" className="w-full h-[560px] object-cover reveal-scale in-view" />
            </div>
            <div className="absolute -bottom-5 right-6 w-28 h-28 rounded-full border-2 border-[#e8e0d2] bg-[#f2ede4]/60 hidden sm:block" />
          </div>

          {/* Accordion */}
          <div className="reveal-right">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#2f9fe6]" />
              <span className="text-[#2f9fe6] tracking-[0.24em] text-xs font-semibold uppercase">What We Do</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f2740] leading-tight mb-6">
              Home Renovations Built to Last
            </h2>
            <p className="text-[#6b7683] text-lg leading-relaxed mb-8">
              We specialize in complete home renovations — kitchens, bathrooms, basements, and every living space that makes your house feel like home. From layout changes to custom finishing details, we help Edmonton homeowners create spaces that are functional, comfortable and thoughtfully built.
            </p>

            <div className="divide-y divide-[#e2e7ec] border-t border-[#e2e7ec]">
              {items.map((s, i) => (
                <div key={s.slug}>
                  <button
                    onClick={() => setOpen(open === i ? -1 : i)}
                    className="w-full flex items-center gap-4 py-5 text-left group"
                  >
                    <span className={`shrink-0 text-2xl font-light leading-none w-5 transition-colors ${open === i ? "text-[#2f9fe6]" : "text-[#0f2740] group-hover:text-[#2f9fe6]"}`}>
                      {open === i ? "\u2212" : "+"}
                    </span>
                    <span className={`flex-1 font-display text-lg sm:text-xl font-semibold tracking-wide transition-colors ${open === i ? "text-[#2f9fe6]" : "text-[#0f2740] group-hover:text-[#2f9fe6]"}`}>
                      {s.title}
                    </span>
                    <span className={`shrink-0 w-11 h-11 rounded-full flex items-center justify-center transition-all group-hover:scale-105 ${open === i ? "bg-[#2f9fe6] text-white" : "bg-[#0f2740] text-white"}`}>
                      <ArrowRight className="w-5 h-5" />
                    </span>
                  </button>
                  <div className={`overflow-hidden transition-all duration-500 ${open === i ? "max-h-[420px] pb-7" : "max-h-0"}`}>
                    <div className="pl-9 pr-4">
                      <p className="text-[#6b7683] text-[15px] leading-relaxed mb-5">{s.short}</p>
                      <Link to="/services" className="group/link inline-flex items-center gap-2 text-[#2f9fe6] font-semibold hover:gap-3 transition-all">
                        Find out more
                        <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/services" className="group inline-flex items-center gap-2 mt-8 text-[#0f2740] font-semibold hover:text-[#2f9fe6] transition-colors">
              Explore all services
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
